import React from 'react';
import { useSelector } from 'react-redux';

// components
import { YesNo, DatePicker, TextInput } from '../components/inputs';
import { FormRow } from '../components/layout';
import { Collapse } from '../../../common/components';

function LTCF() {
  const { ltcf } = useSelector(store => store.values);

  return (
    <div>
      <FormRow>
        <YesNo
          label="Are you currently in a long term care facility?"
          name="ltcf"
          unsetFieldsOnFalse={[
            'ltcf_name',
            'ltcf_date',
            'ltcf_tel',
            'ltcf_addr_street1',
            'ltcf_addr_street2',
            'ltcf_addr_city',
            'ltcf_addr_state',
            'ltcf_addr_zip',
          ]}
        />
      </FormRow>
      <Collapse indent isOpen={ltcf} recalculateHeightOnChange={ltcf}>
        <FormRow>
          <TextInput
            label="Facility name"
            name="ltcf_name"
            cols="6"
          />
          <DatePicker
            label="Date entered the facility"
            name="ltcf_date"
            cols="6"
          />
        </FormRow>
        <FormRow>
          <TextInput
            label="Institution phone number"
            name="ltcf_tel"
            cols="6"
          />
        </FormRow>
        <FormRow>
          <TextInput
            label="Street address line 1"
            name="ltcf_addr_street1"
          />
        </FormRow>
        <FormRow>
          <TextInput
            label="Street address line 2"
            name="ltcf_addr_street2"
          />
        </FormRow>
        <FormRow>
          <TextInput
            label="City"
            name="ltcf_addr_city"
            cols="6"
          />
          <TextInput
            label="State"
            name="ltcf_addr_state"
            cols="6"
          />
        </FormRow>
        <FormRow className="mb-0">
          <TextInput
            label="Zip code"
            name="ltcf_addr_zip"
            cols="6"
          />
        </FormRow>
      </Collapse>
    </div>
  );
}

export default LTCF;
